module.exports = __webpack_public_path__ + "images/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/vue-blu/dist/fonts/fontawesome-webfont.woff2
// module id = 952
// module chunks = 2